import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@service/core/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.usuario && this.auth.menus) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/core/auth-guard.service.ts